import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';
import { InsightsInformationType } from 'crono-fe-common/types/enums/insightsInformationType';

export const StrategyAutomationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: ${colors.black};
  height: 100%;

  .number-of-automations-badge {
    height: 24px;
    padding: 4px 8px;
    background: ${colors.grey4};
    color: ${colors.black};
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  .icon-in-text-wrapper {
    display: inline-flex;
    align-items: center;
    position: relative;
    bottom: -4px;
    padding-left: 6px;
  }

  .arrow {
    flex-shrink: 0;
    cursor: pointer;
    &.disabled {
      cursor: default;
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .automations-options-container {
    display: flex;
    flex-direction: column;
    overflow: auto;

    .automations-container {
      display: flex;
      flex-direction: column;
      gap: 16px;

      .automation-box {
        display: flex;
        flex-direction: column;

        .automation-box-header {
          padding: 12px;
          border-bottom: 1px solid ${colors.grey444};
          display: flex;
          gap: 8px;
          justify-content: space-between;
          align-items: flex-start;
          min-height: 118px;

          .icon-verification,
          .icon-starts-insights {
            flex-shrink: 0;
          }
          .icon-verification {
            height: 24px;
            width: 24px;
          }

          .automation-switch {
            margin-top: -6px;
            margin-bottom: -6px;
            margin-right: -8px;
          }

          &.flat-bottom {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            min-height: unset;
          }
          &.disabled {
            pointer-events: none;
            opacity: 0.5;
            cursor: default !important;
          }
          &.active {
            background: ${colors.primaryLight};
          }
        }

        .automation-box-footer {
          overflow: auto;

          border-bottom: 1px solid ${colors.grey444};
          border-top: none;

          display: flex;
          flex-direction: column;
          padding: 12px;
          gap: 8px;

          .information-block {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 8px;
            border-radius: 6px;
            border: 1px solid ${colors.grey444};

            &.selected {
              background: ${colors.sequenceCardHover};
            }

            .rewrite-checkbox,
            .validation-checkbox {
              border-radius: 6px;
              padding: 8px;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 32px;

              & > * {
                margin: 0;
              }
            }

            .validation-checkbox {
              border-color: ${colors.grey33};
              margin-left: auto;
            }

            .validation-icon-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 6px;
              border: 1px solid ${colors.grey444};
              height: 32px;
              width: 32px;
              padding: 8px;
              background: ${colors.white};
            }

            .text-wrapper {
              display: flex;
              flex-direction: column;
            }

            &.${InsightsInformationType.GENERAL_INFO},
              &.${InsightsInformationType.CURRENT_COMPANY} {
              &.selected {
                background: ${colors.primaryLight};
              }
              .rewrite-checkbox {
                background: ${colors.primaryLightHover};
              }
            }

            &.${InsightsInformationType.EXPERIENCE} {
              &.selected {
                background: ${colors.profileViewLight};
              }
              .rewrite-checkbox {
                background: ${colors.purpleLightHover};
              }
            }

            &.${InsightsInformationType.SOCIAL_PRESENCE} {
              &.selected {
                background: ${colors.socialPresenceLight};
              }
              .rewrite-checkbox {
                background: ${colors.socialPresenceIcon};
              }
            }

            &.${InsightsInformationType.KEY_TOPICS} {
              &.selected {
                background: ${colors.keyTopicsLight};
              }
              .rewrite-checkbox {
                background: ${colors.nurtureLightHover};
              }
            }

            &.${InsightsInformationType.JOB_OPENINGS} {
              &.selected {
                background: ${colors.jobOpeningsLight};
              }
              .rewrite-checkbox {
                background: ${colors.customerLightHover};
              }
            }

            &.${InsightsInformationType.NEWS} {
              &.selected {
                background: ${colors.companyNewsLight};
              }
              .rewrite-checkbox {
                background: ${colors.companyNewsIcon};
              }
            }

            &.${InsightsInformationType.FUNDING_ROUNDS} {
              &.selected {
                background: ${colors.fundingRounds};
              }
              .rewrite-checkbox {
                background: ${colors.fundingRoundsIcon};
              }
            }
          }
        }

        .info-banner {
          display: flex;
          gap: 8px;
          padding: 4px;
          background: ${colors.lightGreenBlue};
          border-radius: 4px;
        }
      }
      .edit-product-info-box {
        cursor: pointer;
        display: flex;
        align-items: center;
        color: ${colors.primary};
        gap: 2px;
        :hover {
          color: ${colors.primaryDark};
          > svg {
            path {
              stroke: ${colors.primaryDark};
            }
          }
        }
      }
      .template-assistant-box {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: ${colors.mainDark};
        .fake-select {
          border: 1px solid ${colors.grey444};
          border-radius: 8px;
          padding: 8px 8px 8px 16px;
          gap: 10px;
          overflow: hidden;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          :hover {
            border-color: ${colors.grey2};
          }
        }
        .box-content-product-info {
          border: 1px solid ${colors.grey444};
          border-radius: 8px;
          width: 100%;
          padding: 8px;
          font-size: 14px;
          line-height: 26px;
          .empty-box {
            cursor: pointer;
            background: ${colors.grey6};
            padding: 2px 8px;
            border-radius: 8px;
            color: ${colors.grey11};
            :hover {
              background: ${colors.grey444};
            }
          }
          .variable-value {
            color: ${colors.rewriteCredits};
          }
        }
      }
    }
  }
`;

export const StrategyAutomationsSidebarWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 380px;
  display: flex;
  z-index: 10;
  padding: 12px;
  font-family: 'Poppins', sans-serif;

  .container {
    border: 1px solid ${colors.grey444};
    border-radius: 16px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    background: ${colors.white};
  }
`;

export const StrategyAutomationsModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${colors.white};
  border-radius: 16px;
  overflow: hidden;
  box-sizing: border-box;
  border: 1px solid ${colors.grey444};
  position: relative;

  .modal-cross {
    position: absolute;
    top: 24px;
    right: 24px;
  }
`;

export const StrategyAutomationsActiveBadge = styled.div`
  background: ${colors.primary};
  color: ${colors.white};
  border-radius: 8px;
  flex-shrink: 0;
  height: 16px;
  max-width: 50px;
  padding: 2px 4px;
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
`;
